import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '../ui';
import Header from '../resale/seller/components/header'
import TicketForm from '../ticket-form/form';
import BackContainer from '../resale/seller/components/backContainer'

export default function UpdateTicketForm({ config, onSubmit }) {
	const { t } = useTranslation();

	const menu = config['update-ticket-form'];
	const { header, fields, pricing, actions, errors = {} } = menu;
	const { id: attendeeId } = header;

	const _onSubmit = () => {
		return onSubmit({
			data: {
				action: 'TicketMenuStep',
				payload: {
					attendee_id: attendeeId
				}
			}		
		}
	)}

	return (
		<Box className="wz-order-menu">
			<div className='wz-neo-ticket-menu-back'>
				<BackContainer title={t('widget.ticketForm.title')} onClick={_onSubmit}/>
			</div>
			<Header data={header}/>
			<TicketForm fields={fields} attendeeId={attendeeId} onSubmit={onSubmit} actions={actions} formErrorsBackend={errors} pricing={pricing} currency={header.currency} />
		</Box>
	)
}
